import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { createPortal } from 'react-dom';

import { getPhotoData } from "~/providers/martine-photos";

import "./style.less";

const PortalComponent = ({ children }) => {
	const portal = createPortal(
		<div className="modal">
			{children}
		</div>,
		document.getElementById("portal"),
	);

	return portal;
};
const PHOTOS = "fotky";

export default function GalleryPage() {
	const navigate = useNavigate();
	const galleryEl = useRef(null);
	const { child, seo } = useParams();
	const [galleryImg, setGalleryImg] = useState(null);
	const [imgLoaded, setImageLoaded] = useState(false);

	let gallery = null;

	if (child === "martinek") {
		const filtered = getPhotoData().filter(item => item.seo === seo);

		gallery = filtered.length === 1 ? filtered[0] : null;
	}

	function backToGalleries() {
		if (child === "martinek") {
			navigate(`/martinek`);
		}
	}

	function showPhoto(data) {
		setImageLoaded(false);
		setGalleryImg(data);
	}

	function closeFullScreen() {
		setImageLoaded(false);
		setGalleryImg(null);
	}

	function openPhoto(direction) {
		const newImg = gallery.imgs.filter(img => img.seo === galleryImg.seo + direction);

		if (newImg.length) {
			setImageLoaded(false);
			setGalleryImg(newImg[0]);
		}
	}

	function prevPhoto(event) {
		event.stopPropagation();
		openPhoto(-1);
	}

	function nextPhoto(event) {
		event.stopPropagation();
		openPhoto(1);
	}

	useEffect(() => {
		/* eslint-disable no-magic-numbers */
		function keyDown(ev) {
			if (ev.which === 27) {
				closeFullScreen();
			} else if (ev.which === 37 && galleryImg) {
				openPhoto(-1);
			} else if (ev.which === 39 && galleryImg) {
				openPhoto(1);
			}
		}

		document.addEventListener("keydown", keyDown);
		galleryEl.current.scrollIntoView();

		return () => {
			document.removeEventListener("keydown", keyDown);
		};
	}, []);

	return <div className="galleryPage" ref={galleryEl}>
		{ gallery && gallery.type === PHOTOS && <>
			<h2 className="galleryPage__title">{gallery.title}</h2>
			<div className="galleryPage__btnCover">
				<button type="button" className="galleryPage__btn" onClick={backToGalleries}>Seznam galerií</button>
			</div>
			<div className="galleryPage__photos">
				{ gallery.imgs.map(item => <div className="galleryPage__photo" key={item.seo} onClick={() => showPhoto(item)}>
					<div className="galleryPage__photoCont">
						<img src={item.src} alt={item.alt} className="galleryPage__photoImg" />
					</div>
				</div>)}
			</div>
		</>}
		{ galleryImg && <PortalComponent>
			<div className="galleryPage__photoOverlay" onClick={closeFullScreen}>
				<div className="galleryPage__photoOverlayPanel left" onClick={prevPhoto}>
					<span className="galleryPage__photoOverlayIcon">{"\u2190"}</span>
				</div>
				<img src={galleryImg.largeSrc} alt={galleryImg.alt} className="galleryPage__photoOverlayImg" onLoad={() => setImageLoaded(true)} style={{
					display: imgLoaded ? "block" : "none",
				}} />
				{ imgLoaded ? null : <div className="galleryPage__photoOverlayLoader"></div> }
				<div className="galleryPage__photoOverlayPanel right" onClick={nextPhoto}>
					<span className="galleryPage__photoOverlayIcon">{"\u2192"}</span>
				</div>
			</div>
		</PortalComponent>}
	</div>;
}
